import React from 'react';
import styles from './index.module.scss'
import './index.module.scss'
import Marquee from "react-fast-marquee";
import Galaxy from '@/assets/image/home/brand2/Icon-Galaxy.png'
import Circle from '@/assets/image/home/brand2/Icon-Circle.png'
import AnchorageDigital from '@/assets/image/home/brand2/Icon-Anchorage Digital.png'
import Fireblocks from '@/assets/image/home/brand2/Icon-Fireblocks.png'
import Visa from '@/assets/image/home/brand2/Icon-Visa.png'
import Salesforce from '@/assets/image/home/brand2/Icon-Salesforce.png'
import Fidelity from '@/assets/image/home/brand2/IconFideLitys.png'
import BitOrigin from '@/assets/image/home/brand2/Icon-Brigin.png'
import Ceffu from '@/assets/image/home/brand2/Icon-Ceffu.png'


import Sui from '@/assets/image/home/brand2/Icon-Sui.png'
import Solana from '@/assets/image/home/brand2/Icon-Solana.png'
import Starknet from '@/assets/image/home/brand2/Icon-Starknet.png'
import Polygon from '@/assets/image/home/brand2/Icon-Polygon.png'
import Ethereum from '@/assets/image/home/brand2/Icon-ethereum.png'
import KiteAI from '@/assets/image/home/brand2/Icon-KiteAI.png'
import Salyer from '@/assets/image/home/brand2/Icon-Solayer.png'
import MANTLE from '@/assets/image/home/brand2/Icon-MANTLE.png'
import ZKsync from '@/assets/image/home/brand2/Icon-ZKsync.png'
import OG from '@/assets/image/home/brand2/Icon-OG.png'
import BASE from '@/assets/image/home/brand2/Icon-Base.png'
import BNB from '@/assets/image/home/brand2/Icon-BNB chain.png'
import Avalanche from '@/assets/image/home/brand2/Icon-Avalanche.png'

import Stanford from '@/assets/image/home/brand2/Icon-Stanford.png'
import MIT from '@/assets/image/home/brand2/Icon-MIT.png'
import UCSB from '@/assets/image/home/brand2/Icon-USCB.png'
import Brown from '@/assets/image/home/brand2/Icon-Brown.png'
import UCBerkeley from '@/assets/image/home/brand2/Icon-UCBerkeley.png'
import CMU from '@/assets/image/home/brand2/Icon-CMU.png'
import NYU from '@/assets/image/home/brand2/Icon-NYU.png'

const InfiniteSlider = ({ items }) => {

  return (
    <div className={`${styles.slider1} trust-ticker relative`} style={{ width: '100%', overflow: 'hidden' }}>
      <Marquee className="slider-wrap" autoFill={true} speed={40} style={{ marginBottom: '24px' }}>
        {/*<div className="slide">*/}
        {/*  <div className={`${styles.icon1} ${styles.icon}`}>*/}
        {/*    <img src={Galaxy} />*/}
        {/*  </div>*/}
        {/*</div>*/}
        <div className="slide">
          <div className={`${styles.icon}`}>
            <img src={Circle} />
          </div>
        </div>
        <div className="slide">
          <div className={`${styles.icon}`}>
            <img src={AnchorageDigital} />
          </div>
        </div>
        {/*<div className="slide">*/}
        {/*  <div className={`${styles.icon}`}>*/}
        {/*    <img src={Fireblocks} />*/}
        {/*  </div>*/}
        {/*</div>*/}
        {/*<div className="slide">*/}
        {/*  <div className={`${styles.icon}`}>*/}
        {/*    <img src={Visa} />*/}
        {/*  </div>*/}
        {/*</div>*/}
        <div className="slide">
          <div className={`${styles.icon}`}>
            <img src={Salesforce} />
          </div>
        </div>
        <div className="slide">
          <div className={`${styles.icon}`}>
            <img src={Fidelity} />
          </div>
        </div>
        <div className="slide">
          <div className={`${styles.icon}`}>
            <img src={BitOrigin} />
          </div>
        </div>
        <div className="slide">
          <div className={`${styles.icon}`}>
            <img src={Ceffu} />
          </div>
        </div>
      </Marquee>

      <Marquee className="slider-wrap" autoFill={true} speed={40} direction="right" style={{ marginBottom: '24px' }}>
        <div className="slide">
          <div className={`${styles.icon}`}>
            <img src={Sui} />
          </div>
        </div>
        <div className="slide">
          <div className={`${styles.icon}`}>
            <img src={Solana} />
          </div>
        </div>
        <div className="slide">
          <div className={`${styles.icon}`}>
            <img src={Ethereum} />
          </div>
        </div>
        {/*<div className="slide">*/}
        {/*  <div className={`${styles.icon}`}>*/}
        {/*    <img src={Starknet} />*/}
        {/*  </div>*/}
        {/*</div>*/}
        {/*<div className="slide">*/}
        {/*  <div className={`${styles.icon}`}>*/}
        {/*    <img src={Polygon} />*/}
        {/*  </div>*/}
        {/*</div>*/}
        <div className="slide">
          <div className={`${styles.icon}`}>
            <img src={KiteAI} />
          </div>
        </div>
        <div className="slide">
          <div className={`${styles.icon}`}>
            <img src={Salyer} />
          </div>
        </div>
        {/*<div className="slide">*/}
        {/*  <div className={`${styles.icon}`}>*/}
        {/*    <img src={MANTLE} />*/}
        {/*  </div>*/}
        {/*</div>*/}
        {/*<div className="slide">*/}
        {/*  <div className={`${styles.icon}`}>*/}
        {/*    <img src={ZKsync} />*/}
        {/*  </div>*/}
        {/*</div>*/}
        <div className="slide">
          <div className={`${styles.icon}`}>
            <img src={OG} />
          </div>
        </div>
        <div className="slide">
          <div className={`${styles.icon}`}>
            <img src={BASE} />
          </div>
        </div>
        <div className="slide">
          <div className={`${styles.icon}`}>
            <img src={BNB} />
          </div>
        </div>
        <div className="slide">
          <div className={`${styles.icon}`}>
            <img src={Avalanche} />
          </div>
        </div>
      </Marquee>

      <div className="slider-wrap flex flex-center">
        <div className="slide">
          <div className={`${styles.icon}`}>
            <img src={NYU} />
          </div>
        </div>
        <div className="slide">
          <div className={`${styles.icon}`}>
            <img src={CMU} />
          </div>
        </div>
        <div className="slide">
          <div className={`${styles.icon}`}>
            <img src={MIT} />
          </div>
        </div>
        <div className="slide">
          <div className={`${styles.icon}`}>
            <img src={Stanford} />
          </div>
        </div>
        <div className="slide">
          <div className={`${styles.icon}`}>
            <img src={UCBerkeley} />
          </div>
        </div>
        <div className="slide">
          <div className={`${styles.icon}`}>
            <img src={Brown} />
          </div>
        </div>
        <div className="slide">
          <div className={`${styles.icon}`}>
            <img src={UCSB} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default InfiniteSlider;
